module.exports = __webpack_public_path__ + "static/img/Krux-Selected.0abfb17.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Krux-Selected.png
// module id = 607
// module chunks = 0